import React, { useState, useCallback } from 'react';
import { Send } from 'lucide-react';
import { MAX_USER_TURNS } from './chatUtils';

export const ChatInput = ({ onSend, disabled, userTurns }) => {
  const [value, setValue] = useState('');

  const submit = useCallback(() => {
    const trimmed = value.trim();
    if (!trimmed || disabled) return;
    onSend(trimmed);
    setValue('');
  }, [value, disabled, onSend]);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      submit();
    }
  };

  return (
    <div className="border-t border-[#D4AF37]/15 p-3 bg-black/60">
      <div className="flex items-end gap-2">
        <input
          type="text"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Type your answer..."
          disabled={disabled}
          className="flex-1 bg-white/[0.05] border border-white/[0.08] rounded-full px-4 py-2.5 text-sm text-white placeholder-white/30 focus:outline-none focus:border-[#D4AF37]/50 transition-colors"
          data-testid="chat-input"
        />
        <button
          type="button"
          onClick={submit}
          disabled={!value.trim() || disabled}
          className="w-10 h-10 rounded-full bg-gradient-to-br from-[#F3E5AB] via-[#D4AF37] to-[#AA8022] text-black flex items-center justify-center disabled:opacity-40 disabled:cursor-not-allowed hover:shadow-md transition-shadow"
          data-testid="chat-send-btn"
          aria-label="Send message"
        >
          <Send className="w-4 h-4" strokeWidth={2} />
        </button>
      </div>
      <p className="text-[10px] uppercase tracking-[0.15em] text-white/25 text-center mt-2">
        {userTurns}/{MAX_USER_TURNS} · Details are not stored
      </p>
    </div>
  );
};
